import React from "react";

const FourOFour = () => {
  return <div>404 PAGE NOT FOUND :(</div>;
};

export default FourOFour;
